import React, { useRef } from 'react';

import { ExportFormat } from '../../../apis/graphql/types';
import { useOnClickOutside } from '../../../hooks';
import { formatOptions } from '../../../pages/baymax/Report/Shared/ReportForm/constants';
import { Item, Wrapper } from './styled';

export type ExportOptionsProps = {
  onClick: (value: ExportFormat) => void;
  onClickOutside?: () => void;
};

const ExportOptions = ({ onClick, onClickOutside = (): void => void 0 }: ExportOptionsProps): JSX.Element => {
  const ref = useRef<HTMLUListElement>(null);

  useOnClickOutside(ref, onClickOutside);

  return (
    <Wrapper ref={ref} data-testid="downloadOptions">
      {formatOptions.map(({ label, value }) => (
        <Item data-testid={`${label.toLowerCase()}Item`} key={value} onClick={(): void => onClick(value)}>
          {label}
        </Item>
      ))}
    </Wrapper>
  );
};

export default ExportOptions;
